/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_SetupInputs */

const en_directory_submit_badge_setup = /** @type {(inputs: Directory_Submit_Badge_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up badge`)
};

const zh_directory_submit_badge_setup = /** @type {(inputs: Directory_Submit_Badge_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置徽章`)
};

/**
* | output |
* | --- |
* | "Set up badge" |
*
* @param {Directory_Submit_Badge_SetupInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_setup = /** @type {((inputs?: Directory_Submit_Badge_SetupInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_SetupInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_setup(inputs)
	return zh_directory_submit_badge_setup(inputs)
});
export { directory_submit_badge_setup as "directory.submit.badge_setup" }